import Image from 'next/image';
import ArrowRight from '@/components/Common/ArrowRight';
import { IModuleStarterCard } from '@/shared/types/platform-pages';
import { NextRouter, useRouter } from 'next/router';
import { useState } from 'react';
import './index.less';

const ModuleStarterCard = ({ pill, icon, title, desc, button, color }: IModuleStarterCard) => {
  const router: NextRouter = useRouter();
  const [isHovering, setIsHovering] = useState<boolean>(false);
  return (
    <div
      className="module-starter-card"
      style={{ border: `1px solid ${isHovering ? color : '#fff'}` }}
      onClick={() => button.onClick(router)}
      onMouseOver={() => setIsHovering(true)}
      onMouseOut={() => setIsHovering(false)}
    >
      <div className="card-body">
        <span className="pill" style={{ color: color }}>
          {pill}
        </span>
        <div className="content">
          <Image className="image" src={icon} alt={title} width={56} height={56} />
          <div className="text">
            <span className="title">{title}</span>
            <span className="desc">{desc}</span>
          </div>
        </div>
      </div>
      <div className="button" style={{ backgroundColor: button.bgColor }}>
        <span className="text" style={{ color: button.color }}>
          {button.text}
        </span>
        <ArrowRight color={button.color} width={12} height={12} />
      </div>
    </div>
  );
};

export default ModuleStarterCard;
